var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"id":"snackbar","timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('b',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }